import React from "react";
import { Icon } from "./icons";

const ITEMS = [
  {
    icon: "pin",
    title: "Trajets partout en France & en Europe",
    text: "Villes, aéroports, gares, entreprises, événements, séminaires…",
  },
  {
    icon: "driver",
    title: "Chauffeure VTC féminine",
    text: "À votre écoute pour un service personnalisé et bienveillant.",
  },
  {
    icon: "passengers",
    title: "Jusqu'à 7 passagers",
    text: "Voyagez en groupe, en famille ou entre collègues.",
  },
];

export const BottomBar = () => (
  <section className="bottom-bar">
    <div className="container bottom-bar-inner">
      {ITEMS.map((b) => (
        <div className="bottom-item" key={b.title}>
          <span className="bottom-icon">
            <Icon name={b.icon} size={22} />
          </span>
          <div>
            <h3>{b.title}</h3>
            <p>{b.text}</p>
          </div>
        </div>
      ))}

      <a href="#contact" className="btn btn-primary bottom-cta">
        Demander un devis
        <em>Réponse rapide et personnalisée</em>
      </a>
    </div>
  </section>
);

export default BottomBar;
